
// jQuery('form.variations_form.cart').off('check_variations')

jQuery(document.body).on('found_variation', 'form.cart', (e, data) => {
  jQuery('input[name="variation_id"]').val(data.variation_id)
})

const blockUiOptions = { message: null, overlayCSS: { background: '#fff', opacity: 0.6 } }

if (jQuery('body').hasClass('single-product')) {

  jQuery(document).on('change', '.custom-select', () => {
    updateVariationOptions()
  })
  jQuery(document).on('click', '.radio--button input', updateSelectWhenRadioChanges)

  // jQuery('form.variations_form').trigger('check_variations')
  const setup = new Promise((resolve, reject)=>{
    renderVariationRadios()
    resolve(true)
  }).then((update) => updateVariationOptions(update))
}


function updateVariationOptions(updateSize = false) {
  let $form = jQuery('form.variations_form')
  // console.log($form.serializeArray())
  const data = {
    action: 'get_variation_options',
      fields: $form.serializeArray(),
      updateSize,
      parent: $form.data('product_id')
  }
  jQuery.ajax({
    url: TG.ajaxUrl,
    method: 'GET',
    data,
    beforeSend() {
        // console.log('Before Send')
        // console.log($form)
        $form.block(blockUiOptions)
    },
    success(response) {
      if (!response.success) {
        //console.warn(response.data)
      } else {
        // console.log(response)
        const attributes = response.data
        $form.find('.custom-select').each((index, select) => {
          let $select = jQuery(select)
          attributes.forEach(attribute => {
            if (attribute.name === $select.attr('id')) {
              let currentVal = $select.val()

              if (!attribute.options.includes(currentVal)) {
                $select.val("")
              }

              $select.children().each((index, option) => {
                option.disabled = !attribute.options.includes(option.value)
  
                if (option.disabled && option.selected) {
                  option.selected = false
                }
              })
            }
          })
        })

        updateVaraitionRadios(attributes)
      }
      
      $form.unblock()
    },
    complete() {
      updateCurrentStateOnLabels()
      jQuery('form.variations_form').trigger('check_variations')
    }
  })
}

function updateCurrentStateOnLabels() {
  jQuery('form.variations_form').find('.custom-select').each((index, select) => {
    let $select = jQuery(select)
    let option = $select.children('option:selected')
    jQuery(`label[for="${$select.attr('id')}"] .current-value`).text(option.text())
  })
}

function renderVariationRadios() {
  jQuery('.custom-select').each((index, select) => {
    const $select = jQuery(select)
    let html = `<ul class="variation__radio-group nav">`
    $select.children('[value!=""]').each((index, option) => {     
        let radioId = `${select.id}--${option.value}`
        html += `
        <li class="radio--button">
          <input
            id="${radioId}"
            type="radio"
            name="${$select.attr('id')}"
            ${option.selected ? 'checked': ''}
            ${option.disabled ? 'disabled': ''}
            value="${option.value}">
          <label for="${radioId}">${option.innerText}</label>
        </li>
        `
    })
    html += '<ul>'
    $select.after(html)
  })
}

function updateVaraitionRadios(attributes) {
  attributes.forEach((attribute, index) => {
    let attributeId = attribute.name
    let attributeOptions = attribute.options

    jQuery(`.radio--button input[name="${attributeId}"]`).each((index, radio) => {
        radio.disabled = !attributeOptions.includes(radio.value)

        if (radio.disabled && radio.checked) {
          radio.checked = false
        }
    })
  })

  // jQuery(document.body).trigger('check_variations')
}


function updateSelectWhenRadioChanges() {
  let $button = jQuery(this)
  let $select = jQuery(`#${$button.attr('name')}`)
  
  $select.val($button.val())
  updateVariationOptions()
  // jQuery('form.variations_form').trigger('check_variations')
    // .trigger('change')
}
